// extracted by mini-css-extract-plugin
export default {"IconButton":"IconButton_IconButton__r-hpi","primary":"IconButton_primary__pwGs5","secondary":"IconButton_secondary__F1g16"};